import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { getItemBasePrice, getVariantTotal, sortVariantFieldsByRank } from "../../util";
import HTMLViewer from "../HTMLViewer";
import currency from "currency.js";

export default function LineItemDetails(props) {
  const { item } = props;

  const getVariantSurcharge = (variant, item) => {
    if (variant) {
      const basePrice = getItemBasePrice(item?.variant);
      const surcharge = getVariantTotal({ variant }, basePrice);
      if (surcharge) {
        return `(+${currency(surcharge).format()})`;
      }
    }
    return "";
  };

  return (
    <Box>
      {item.variant &&
        Object.entries(item.variant)
          .sort(([k1, v1], [k2, v2]) =>
            sortVariantFieldsByRank({ key: k1, ...v1 }, { key: k2, ...v2 })
          )
          .map(([key, value]) => {
            return (
              <Box my={0.5}>
                <Typography variant="overline" color="textSecondary">
                  {value.field?.name || key} {getVariantSurcharge(item.variant[key], item)}
                </Typography>
                <Typography variant="body2">{value?.name}</Typography>
              </Box>
            );
          })}
      {item.tags && item.tags.length > 0 && (
        <Box my={0.5}>
          <Typography variant="overline" color="textSecondary" display="block">
            TAGS
          </Typography>
          {item.tags.map((e, idx) => (
            <Chip key={idx} size="small" label={e} />
          ))}
        </Box>
      )}
      {item.description && (
        <Box my={0.5}>
          <Typography variant="overline" color="textSecondary" display="block">
            NOTES
          </Typography>
          <HTMLViewer content={item.description} style={{ fontSize: ".85rem" }} />
        </Box>
      )}
    </Box>
  );
}
